import { createContext, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
var RouterStatsImpl = /** @class */ (function () {
    function RouterStatsImpl(initialPath) {
        this._initialPath = initialPath;
        this._visitedRoutes = new Map([[initialPath, 0]]);
    }
    Object.defineProperty(RouterStatsImpl.prototype, "initialPath", {
        get: function () {
            return this._initialPath;
        },
        enumerable: false,
        configurable: true
    });
    RouterStatsImpl.prototype.isInitialLoad = function (currentPath) {
        var _a;
        return (((_a = this._visitedRoutes.get(currentPath)) !== null && _a !== void 0 ? _a : 0) === 1 &&
            this._visitedRoutes.size === 1 &&
            currentPath === this._initialPath);
    };
    RouterStatsImpl.prototype.isInitialVisit = function (currentPath) {
        var _a;
        return (this.isInitialLoad(currentPath) ||
            ((_a = this._visitedRoutes.get(currentPath)) !== null && _a !== void 0 ? _a : 0) === 0);
    };
    RouterStatsImpl.prototype.addVisitedRoute = function (pathName) {
        var _a;
        var currentEntry = (_a = this._visitedRoutes.get(pathName)) !== null && _a !== void 0 ? _a : 0;
        this._visitedRoutes.set(pathName, currentEntry + 1);
    };
    return RouterStatsImpl;
}());
export { RouterStatsImpl };
export var RouterStatsContext = createContext(null);
// hook to capture router statistics
export var useRouterStats = function () {
    var location = useLocation();
    var initialPath = useRef(location.pathname);
    var stats = useMemo(function () { return new RouterStatsImpl(initialPath.current); }, []);
    useEffect(function () {
        stats.addVisitedRoute(location.pathname);
    }, [location.pathname]);
    return stats;
};
//# sourceMappingURL=RouterStats.js.map